import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { Store } from '@ngrx/store';

import { extractValueFromStore } from '@ninety/platform/services';
import { LinkedItemsActions } from '@ninety/web/pages/detail-view/_shared/linked-items/_state/linked-items.actions';
import { MeetingService } from '@ninety/web/pages/meeting/_shared/services/meeting.service';
import { selectPlanningBoardPageView } from '@ninety/web/pages/rocks/_state/rocks-state.selectors';
import {
  UNIVERSAL_CREATE_LINKED_ITEMS_ADAPTER,
  UNIVERSAL_CREATE_MEETING_CONTEXT,
  UNIVERSAL_CREATE_PLANNING_BOARD_CONTEXT,
  UniversalCreateLinkedItemsAdapter,
  UniversalCreateMeetingContext,
  UniversalCreatePlanningBoardContext,
} from '@ninety/web/pages/universal-create/services/universal-create-external-actions.token';

export function provideUniversalCreateRootAdapters(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: UNIVERSAL_CREATE_LINKED_ITEMS_ADAPTER,
      useFactory: (store: Store): UniversalCreateLinkedItemsAdapter => ({
        createdLinkedItem: payload => store.dispatch(LinkedItemsActions.createdLinkedItem(payload)),
      }),
      deps: [Store],
    },
    {
      provide: UNIVERSAL_CREATE_MEETING_CONTEXT,
      useFactory: (meetingService: MeetingService): UniversalCreateMeetingContext => ({
        isCurrentMeetingInProgress: () => !!meetingService.currentMeeting?.inProgress,
      }),
      deps: [MeetingService],
    },
    {
      provide: UNIVERSAL_CREATE_PLANNING_BOARD_CONTEXT,
      useFactory: (store: Store): UniversalCreatePlanningBoardContext => ({
        isPlanningBoardPageView: () => !!extractValueFromStore(store, selectPlanningBoardPageView),
      }),
      deps: [Store],
    },
  ]);
}
